import { AppDependency } from '@amzn/awscat-portfolio-assessment-types';
import { Box, ExpandableSection, SpaceBetween } from '@amzn/awsui-components-react';
import React from 'react';

import { constants } from '../../../common/Localization';
import { format } from '../../../common/util';

type Props = {
    dependencies: AppDependency[] | null;
}

function ApplicationGroupDependencyHeatMapResourceDetail ({ dependencies }: Props) {

    const buildExpandableSection = (header: string, desc: string, assetIds: string[]) => {
        return (
            <ExpandableSection
                header={header}
                defaultExpanded
            >
                <SpaceBetween size='s'>
                    <Box variant='small'>
                        {desc}
                    </Box>
                    <Box>
                        {assetIds.length > 0 ? assetIds.join(', ') : '-'}
                    </Box>
                </SpaceBetween>
            </ExpandableSection>
        );
    };

    const getContent = (): JSX.Element => {
        const sharedServers: string[] = [];
        dependencies?.filter(dependency => dependency.resourceType.includes('applications-servers'))
            .map(dependency => {
                sharedServers.push(dependency.resourceId);
            });

        const sharedDatabases: string[] = [];
        dependencies?.filter(dependency => dependency.resourceType.includes('database'))
            .map(dependency => {
                sharedDatabases.push(dependency.resourceId);
            });

        return dependencies?.length && dependencies.length > 0 ? (
            <SpaceBetween size='m'>
                <Box variant='h2'>{constants.DEPENDENCY_DETAIL}</Box>
                <Box variant='h3'>{format(constants.APPLICATIONS_FROM_TO, [dependencies[0].srcAppId, dependencies[0].destAppId])}</Box>
                {buildExpandableSection(constants.SHARED_SERVERS, constants.SERVERS_SHARED, sharedServers)}
                {buildExpandableSection(constants.SHARED_DATABASES, constants.DATABASES_SHARED, sharedDatabases)}
            </SpaceBetween>
        ) : (
            <SpaceBetween size='m'>
                <Box variant='h2'>{constants.DEPENDENCY_DETAIL}</Box>
                <Box>{constants.NO_DEPENDENCIES_FOUND}</Box>
            </SpaceBetween>
        );
    };

    return dependencies ? (
        <Box className='group-summary' display='inline-block' float='right'>
            {getContent()}
        </Box>
    ) : null;
}

export default ApplicationGroupDependencyHeatMapResourceDetail;
